import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'Basetao Spreadsheet Ultimate Guide 2026',
    desc: 'Everything you need to know about using Basetao spreadsheets — from finding the best products to mastering shipping and QC.',
    tag: 'Guide',
    tagColor: 'text-primary-600 bg-primary-100/70',
    path: '/basetao-spreadsheet-ultimate-guide',
    image: 'https://readdy.ai/api/search-image?query=Organized%20desk%20with%20laptop%20displaying%20spreadsheet%20data%2C%20warm%20natural%20lighting%2C%20minimalist%20workspace%2C%20cream%20and%20beige%20tones%2C%20editorial%20productivity%20scene%2C%20clean%20composition&width=800&height=500&seq=article-img-guide&orientation=landscape',
  },
  {
    title: 'Basetao Review 2026: Honest Assessment',
    desc: 'In-depth service review covering QC quality, shipping reliability, customer support, and overall value for international shoppers.',
    tag: 'Review',
    tagColor: 'text-accent-600 bg-accent-100/80',
    path: '/basetao-review-2026',
    image: 'https://readdy.ai/api/search-image?query=Person%20unboxing%20fashion%20package%20on%20wooden%20table%2C%20warm%20natural%20light%2C%20cream%20background%2C%20editorial%20lifestyle%20photography%2C%20clean%20minimalist%20aesthetic&width=800&height=500&seq=article-img-review&orientation=landscape',
  },
  {
    title: 'Is Basetao Legit? Full Investigation',
    desc: 'A thorough look at Basetao\'s legitimacy, security measures, payment protection, and community trust before you place your first order.',
    tag: 'Legitimacy',
    tagColor: 'text-secondary-600 bg-secondary-100/80',
    path: '/is-basetao-legit',
    image: 'https://readdy.ai/api/search-image?query=Secure%20online%20shopping%20concept%20with%20credit%20card%20and%20lock%20icon%20on%20warm%20cream%20desk%2C%20soft%20natural%20lighting%2C%20minimalist%20composition%2C%20editorial%20style&width=800&height=500&seq=article-img-legit&orientation=landscape',
  },
  {
    title: 'Complete Shipping Cost Guide 2026',
    desc: 'Detailed breakdown of every Basetao shipping method, real cost estimates by weight and destination, and proven saving strategies.',
    tag: 'Shipping',
    tagColor: 'text-primary-600 bg-primary-100/70',
    path: '/basetao-shipping-cost',
    image: 'https://readdy.ai/api/search-image?query=International%20shipping%20boxes%20and%20parcels%20on%20minimalist%20cream%20surface%2C%20warm%20ambient%20lighting%2C%20clean%20logistics%20photography%2C%20editorial%20composition&width=800&height=500&seq=article-img-shipping&orientation=landscape',
  },
  {
    title: 'Basetao Warehouse Guide & QC Tips',
    desc: 'Everything about warehouse services including free storage duration, QC photo inspection, package consolidation, and return policies.',
    tag: 'Warehouse',
    tagColor: 'text-accent-600 bg-accent-100/80',
    path: '/basetao-warehouse-guide',
    image: 'https://readdy.ai/api/search-image?query=Organized%20warehouse%20shelves%20with%20packages%20in%20warm%20minimalist%20setting%2C%20clean%20cream%20backdrop%2C%20soft%20lighting%2C%20editorial%20industrial%20photography&width=800&height=500&seq=article-img-warehouse&orientation=landscape',
  },
  {
    title: 'Best Coupon & Discount Codes 2026',
    desc: 'The most up-to-date Basetao coupons, promotional offers, seasonal discounts, and proven strategies to reduce your total shopping costs.',
    tag: 'Savings',
    tagColor: 'text-secondary-600 bg-secondary-100/80',
    path: '/basetao-coupon-discount',
    image: 'https://readdy.ai/api/search-image?query=Shopping%20discount%20concept%20with%20fashion%20items%20and%20price%20tags%20on%20warm%20cream%20surface%2C%20minimalist%20composition%2C%20soft%20natural%20lighting%2C%20editorial%20style&width=800&height=500&seq=article-img-coupon&orientation=landscape',
  },
  {
    title: 'Best Basetao Product Finds 2026',
    desc: 'Curated collection of top-rated product discoveries across sneakers, streetwear, accessories, and home goods — all QC verified.',
    tag: 'Products',
    tagColor: 'text-primary-600 bg-primary-100/70',
    path: '/basetao-product-finds',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20fashion%20product%20flatlay%20with%20sneakers%20hoodie%20and%20accessories%20on%20cream%20marble%2C%20warm%20natural%20light%2C%20editorial%20photography%2C%20clean%20minimalist%20composition&width=800&height=500&seq=article-img-finds&orientation=landscape',
  },
  {
    title: 'Basetao vs Competitors: Full Comparison',
    desc: 'Objective side-by-side comparison of Basetao against CSSBuy, Sugargoo, Wegobuy and Pandabuy covering fees, shipping, and QC quality.',
    tag: 'Comparison',
    tagColor: 'text-accent-600 bg-accent-100/80',
    path: '/basetao-vs-competitors',
    image: 'https://readdy.ai/api/search-image?query=Comparison%20chart%20concept%20with%20shopping%20icons%20on%20warm%20cream%20desk%2C%20minimalist%20workspace%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20composition&width=800&height=500&seq=article-img-compare&orientation=landscape',
  },
  {
    title: 'Complete Beginner Guide to Basetao',
    desc: 'Step-by-step walkthrough for placing your first order — from account setup and payment to QC review and international delivery.',
    tag: 'Beginner',
    tagColor: 'text-secondary-600 bg-secondary-100/80',
    path: '/basetao-beginner-guide',
    image: 'https://readdy.ai/api/search-image?query=Person%20laptop%20shopping%20online%20on%20warm%20cream%20desk%2C%20minimalist%20workspace%2C%20soft%20natural%20lighting%2C%20editorial%20lifestyle%20photography%2C%20clean%20composition&width=800&height=500&seq=article-img-beginner&orientation=landscape',
  },
  {
    title: 'Essential Safety Tips for Shoppers',
    desc: 'Security best practices for Basetao users including payment protection, phishing awareness, package insurance, and dispute resolution.',
    tag: 'Safety',
    tagColor: 'text-primary-600 bg-primary-100/70',
    path: '/basetao-safety-tips',
    image: 'https://readdy.ai/api/search-image?query=Secure%20shopping%20concept%20with%20shield%20and%20package%20on%20warm%20cream%20surface%2C%20minimalist%20composition%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style&width=800&height=500&seq=article-img-safety&orientation=landscape',
  },
];

export default function ArticlesSection() {
  return (
    <section id="articles" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Latest Basetao Spreadsheet Guides &amp; Articles
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            In-depth articles and resources to help you master every aspect of the Basetao shopping experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200/70">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <span className={`self-start text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap ${article.tagColor}`}>
                  {article.tag}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mt-3 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1 line-clamp-3">
                  {article.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}